'use strict';

import React ,{Component} from 'react';
import EnvisionNav from './EnvisionNavContainer';
import ImageCard from './ImageCardContainer';


import styled from 'styled-components';
import { css } from 'emotion';
import facepaint from 'facepaint';
import 'vendors/bootstrap/bootstrap.css';
import 'vendors/mdbreact/css/mdb.css';
import 'css/nexa-font.css';

const backgroundImage = '/assets/img/Birnudalstindur.jpeg';
//const backgroundImage = '/assets/img/Namafjall-hverir-10.jpeg';
//const backgroundImage = '/assets/img/background-image3.jpg';


const envisionLogo = '/assets/img/envision-logo-white-text-white-logo.png';
//const envisionLogo = '/assets/img/envision-logo-white.png';


let jsonData = require('./landingpagedata.json');
import CTAButtonContainer from './CTAButtonContainer';

const fontColor = '#FFF';
const openQuote = "„";
const closeQuote = "“";

export  default class HeaderContainer extends React.Component {
  
render() {
  return (
    <PageContainer>
       <EnvisionNav animate={true}/>

      <div style={{position:'relative',flex:'1',minHeight:'80px',backgroundColor:'black'}}/>
      <div style={{flex:'0'}}/>
      <ImageCard
        assignId={"envision-logo"}
        image={envisionLogo}
        animate={false}
        className={css`${logoImageStyle};${logoWidthStyle};`}
        />
   
      <SectionTitle
        title={jsonData.Header.headerTexts.logoSubtitle1}
        triggerAnchor={"#pre-cta-script"}
        animate={true}
        whichAnimation={'fad-out'}
        offset={-240}
        className={css`${logoSubscriptStyle};${logoSubscriptFontStyleProd};`}/>
      <SectionTitle
        title={jsonData.Header.headerTexts.logoSubtitle2}
        triggerAnchor={"#pre-cta-script"}
        animate={true}
        whichAnimation={'fad-out'}
        offset={-310}
        className={css`${logoSubscriptStyle};${logoSubscriptFontStyleProd};${overRidelogoSubscriptStyle};`}/>
      <div  style={{flex:'6'}}/>

      <SectionTitle
        assignId={"pre-cta-script"}
        title={jsonData.Header.headerTexts.preCTAText1}
        className={css`${preCTAStyleFirst};${PreCTAStyleFontStylesProd};${PreCTASQuestionStyles};font-style:normal;font-weight:600;`}/>
      
      
      <div className={css`${preCTAStyleSecond};${PreCTAStyleFontStylesProd};`}>
        {jsonData.Header.headerTexts.preCTAText2}
      </div>
      <SectionTitle
      title={jsonData.Header.headerTexts.CTAText}
      className={css`${CTAStyle};${CTAStyleFontStylesProd}`}/>
       <CTAButtonContainer
          className={css`flex:1;`}
          url={jsonData.Header.headerTexts.ButtonCTAUrl}
          text={jsonData.Header.headerTexts.ButtonCTA}
          buttonStyle={css`${buttonStyles};${buttonFontStyles}`}
          containerStyle={css`${buttonContainerStyle}`}
          />
    </PageContainer>

  );
  }
}

class SectionTitle extends Component {
   constructor(props) {
     super(props);
   }

   render() {
     const  {title, sectionStyle,opacity,animate,offset,className,assignId,whichAnimation,triggerAnchor} = this.props;
     let renderAnimation = whichAnimation;
     if(!renderAnimation)
        renderAnimation = "fad-out";
     if(animate){
       return (<div id={assignId} data-aos={renderAnimation} data-aos-anchor={triggerAnchor} data-aos-offset={offset} data-aos-anchor-placement="top-top" className={className} >{title}</div>);

     }
     else{
       return(<div id={assignId} className={className} style={sectionStyle}>{title}</div>);
     }
   }
 }

 

 //styled components
const PageContainer = styled.section`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;

  background: linear-gradient( rgba(0, 0, 0, 0.05), rgba(1, 1, 1, 0.05)),url(${backgroundImage});
  //background: linear-gradient(25deg,#7F7F7F 3%,rgba(255,255,255,0.2) 42%,rgba(0,0,0,0.0) 100%), url(${backgroundImage});
  //background: linear-gradient(75deg, #9293af -7%, rgba(255,255,255,0.2) 54%, rgba(0,0,0,0.2) 100%), url(${backgroundImage});

  background-size: cover;
  background-position: left;
  background-repeat: no-repeat;
  height: 100%;
  min-height: 320px;
  
 `;

 
 const breakpoints = [480, 576,768,992,1200,1600];

  //Inline styling https://codeburst.io/4-four-ways-to-style-react-components-ac6f323da822
  const logoImageStyle =  {
    margin: "0 1.8rem 0",
    maxWidth: '499px',
    minWidth: '288px',
    width: '288px', 
    height: 'auto',
  };


  const mqlogoStyle = facepaint(
    breakpoints.map(bp => `@media (min-width: ${bp}px)`)
  );
  const logoWidthStyle = css(
    mqlogoStyle({
      width:['298px','307px','307px' ,'348px','430px','477px'],//,'3.0rem'
    }),
  );

const logoSubscriptStyle = {
    position: '-webkit-sticky',
    position: 'sticky',
    top:'75px',
    alignSelf:'flex-start',
    margin: "0 1.8rem 0",
    color: fontColor,
    height: 'auto',
    fontFamily: 'Nexa Light',
    fontWeight: '400',
  };


  const mqOverRidelogoSubscriptStyle = facepaint(
    breakpoints.map(bp => `@media (min-width: ${bp}px)`)
  );

  const overRidelogoSubscriptStyle = css(
    mqOverRidelogoSubscriptStyle({
      top:  ['99px','101px', '101px','107px','109px','114px'],//,'3.0rem'
    }),
  );
/*
  const overRidelogoSubscriptStyle = {
    top:'114px',
  }
*/
  
  const mqlogoFontStyle = facepaint(
    breakpoints.map(bp => `@media (min-width: ${bp}px)`)
  );
  
  const logoSubscriptFontStyleProd = css(
    mqlogoFontStyle({
      fontSize:  ['2.03rem','2.14rem',  '2.16rem','2.49rem','3.30rem','3.96rem'],//,'3.0rem'
      lineHeight:['2.3rem','2.5rem', '2.5rem' ,'3.1rem','3.5rem','4.0rem'],//,'3.0rem'
      letterSpacing: ['7.0px','7.0px', '7.0px' ,'7.6px','8.1px','7.4px'],
      fontWeight: ['600','600', '600' ,'600', '600','600'],
    }),
  );

  //Pre Call To Action Styles
  const preCTAStyleFirst = {
    margin: "0 1.8rem 0rem",
    fontWeight: '600',
    fontFamily: 'Nexa Light',
    //fontStyle: 'italic',
    color:'#FFF'
  };

  const preCTAStyleSecond = {
    margin: "0.3rem 1.8rem 3.5rem",
    fontWeight: '600',
    fontFamily: 'Nexa Light',
    //fontStyle: 'italic',
    color:'#FFF',
    maxWidth:'80%'
  };

  //PRE CALL TO ACTION: Er þetta þinn veruleiki?
  // "Löng biðröð...."
  const mqPreCTAStyle = facepaint(
    breakpoints.map(bp => `@media (min-width: ${bp}px)`)
  );
  

  const PreCTAStyleFontStylesProd = css(
  mqPreCTAStyle({
    fontSize:  ['1.5rem','1.7rem', '2.1rem','2.5rem','2.9rem','3.2rem'],
    lineHeight:['1.5rem','1.7rem', '2.1rem' ,'2.5rem','2.8rem','3.1rem'],
  }),
  );

  const PreCTASQuestionStyles = css(
    mqPreCTAStyle({
      lineHeight:['2.1rem','2.3rem', '2.7rem' ,'3.1rem','3.4rem','3.8rem'],
    }),
    );

  

  //CALL TO ACTION: Settu saman hugbúnaðarteymi sniðið...
  const CTAStyle = css`
    margin: 0.0rem 1.8rem 0rem;
    font-weight: 700;
    font-family: 'Nexa Light';
    color:#FFF;
  `

  const mqCTAStyle = facepaint(
      breakpoints.map(bp => `@media (min-width: ${bp}px)`)
    );

    const CTAStyleFontStylesProd = css(
      mqCTAStyle({
        //color: ['green', 'gray', 'hotpink'],
        fontSize:  ['1.5rem', '1.7rem',  '2.1rem','2.5rem','2.9rem','3.2rem'],
        lineHeight:['1.5rem', '1.6rem', '2.0rem' ,'2.6rem','3.2rem','3.4rem'],
      }),
    );

  const buttonStyles = css`
    color:#FFF;  
    background-color: #E88D67;
    padding: 1.3rem 1.8rem;
    border-radius: 10px;
    text-transform: uppercase;
    font-weight:500;
    margin:2rem 1.8rem 2rem;
    transition: 0.4s;
    &:hover {
      color:#E88D67;
      background-color: #fff;
    }
`
const buttonFontStyles = css(
  mqPreCTAStyle({
    fontSize:['1.3rem','1.5rem', '1.7rem' ,'1.9rem','1.9rem','2.1rem'],
  }),
  );

  const buttonContainerStyle = css`
  flex: 1;
  margin-bottom:1.8rem;
  //text-align:center;
`

  